<template>
  <div v-if="message">
    <span class="grey--text">{{ message.created_at }}</span>
    <v-btn v-if="message.attached" icon flat disabled>
      <v-icon>mdi-paperclip</v-icon>
    </v-btn>
    <v-btn v-else icon flat disabled><v-icon>mdi-message-text</v-icon></v-btn>
    &mdash;
    <span class="grey--text">{{ message.message | truncate(60, '...') }}</span>
  </div>
</template>

<script>
export default {
  props: ['message'],
};
</script>
